<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <b-tabs v-model="tab">
                        <b-tab :title="$t('form_data.form_data')">
                            <data-table :edit-item="editItem" />
                        </b-tab>
                        <b-tab :title="$t('site.add')">
                            <my-form :new-item="newItem" />
                        </b-tab>
                    </b-tabs>
                </div>
                <!-- end of card body -->
            </div>
            <!-- end of card -->
        </div>
        <!-- end of col -->
    </div>
</template>

<script>
    import DataTableVue from "./components/DataTable.vue";
    import FormVue from "./components/Form.vue";

    export default {
        name: "DataFormIndex",
        components: {
            "data-table": DataTableVue,
            "my-form": FormVue,

        },
        data() {
            return {
                newItem: {
                  name:'',
                  mydata:{checkboxs: [{
                      name: '',
                    }],
                    textboxs: [{
                      name: '',
                    }],
                    radiobuttons: [{
                      name: '',
                    }],
                    textareas: [{
                      name: '',
                    }],
                    selectboxs: [{
                      name: '',
                    }]},
                },

                tab: 0,
            };
        },
        methods: {
            editItem(data) {
                this.newItem = data.item;
                this.newItem.mydata=data.item.data;
                this.tab = 1;
            },
        },
    };
</script>
